export const roleTypes = {
  USER: ['USER'],
  ADMIN: ['USER', 'MANAGER', 'ADMIN'],
}

export const roles = {
  USER: 'USER',
  ADMIN: 'ADMIN',
}

export default {
  roleTypes,
  roles,
}



// WEBPACK FOOTER //
// ./src/common/config.js